export default {
      id: "driver-1-usage",
      viewBox: "0 0 17 21",
      url: __webpack_public_path__ + "img/icons.svg#driver-1",
      toString: function () {
        return this.url;
      }
    }